// The twelve resident types of Normalton Square (DESIGN §3) and the bot names (the town-name list, DESIGN §4).
// A body's `costume` on the wire is an index into RESIDENTS; the Inspector wears INSPECTOR_COSTUME.
// Art (meshes, accessories, rig scale) lives in art/types.json, keyed by these ids.

export const RESIDENTS = [
  "grandma", "grandpa", "chef", "mail_carrier", "street_sweeper", "tourist",
  "office_worker", "kid_balloon", "florist", "busker", "gardener", "painter",
] as const;
export type Resident = typeof RESIDENTS[number];
export const INSPECTOR_COSTUME = RESIDENTS.length;   // 12

/** bot seats take these names: ordinary townsfolk names, so a bot never needs a "·bot" tag (the crowd is NPCs by design) */
export const TOWN_NAMES = [
  "Mabel", "Otis", "Hettie", "Percy", "Dot", "Wilbur", "Agnes", "Clem", "Winnie", "Barnaby",
  "Flora", "Horace", "Ivy", "Rupert", "Nell", "Archie", "Pearl", "Fergus", "Tilly", "Monty",
] as const;
